<template>
  <div id="HelpDrawer">
    <v-btn color="info" fixed fab bottom right small @click="open = !open">
      <v-icon dark>help_outline</v-icon>
    </v-btn>
    <v-navigation-drawer app right v-model="open">
      <VuePerfectScrollbar class="app-sidebar-scroll">
        <v-container class="mt-5">
          <v-layout wrap class="mt-3">
            <v-flex>
              <h3 v-if="name" class="primary--text font-weight-black">{{$t(`helpDrawer.${name}.title`)}}</h3>
            </v-flex>
            <v-flex xs12>
              <v-divider/>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <h3 v-if="name" v-html="$t(`helpDrawer.${name}.text`)"/>
            </v-flex>
          </v-layout>
        </v-container>
      </VuePerfectScrollbar>
    </v-navigation-drawer>
  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  name: 'HelpDrawer',
  components: {
    VuePerfectScrollbar
  },
  props: [ 'name' ],
  data () {
    return {
      open: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Layout/Components/HelpDrawer.vue